import { LOG_ENTRIES, type Logbook } from '../game/Logbook';

/** Esc overlay. The shared world keeps running; only local input stops. */
export class PauseMenu {
  readonly root: HTMLDivElement;
  open = false;
  onResume: () => void = () => {};
  onChangeShip: () => void = () => {};
  onVolume: (v: number) => void = () => {};
  onMute: () => boolean = () => false;
  private readonly log: HTMLElement;
  private readonly vol: HTMLInputElement;
  private readonly muteBtn: HTMLButtonElement;

  constructor(parent: HTMLElement, volume: number, muted: boolean) {
    this.root = document.createElement('div');
    this.root.className = 'pause hidden';
    this.root.innerHTML = `
      <div class="pause-card">
        <div class="pause-title">PAUSED <span>the universe keeps moving</span></div>
        <div class="pause-cols">
          <div>
            <button class="pause-btn" data-a="resume">Resume</button>
            <button class="pause-btn" data-a="ship">Change ship</button>
            <label class="pause-vol">Volume <input type="range" min="0" max="1" step="0.01" /></label>
            <button class="pause-btn small" data-a="mute"></button>
            <div class="pause-keys">
              <b>W/S</b> throttle · <b>Mouse</b> steer · <b>A/D</b> roll · <b>R/F</b> up/down · <b>Shift</b> boost · <b>H</b> warp · <b>X</b> stop<br/>
              <b>Click/Space</b> fire · <b>T</b> target · <b>J</b> autopilot · <b>G</b> follow target player · <b>M</b> map<br/>
              <b>C</b> camera · <b>Tab</b> players · <b>Enter</b> chat · <b>N</b> mute
            </div>
          </div>
          <div>
            <div class="pause-sub">LOGBOOK</div>
            <ul class="pause-log"></ul>
          </div>
        </div>
        <div class="pause-credits">Planet textures © Solar System Scope (CC BY 4.0) · Imagery: Esri, Maxar, Earthstar Geographics · Elevation: Mapzen Terrain Tiles (AWS Open Data) · Ships: procedural (built in code) · Rocks: Poly Haven (CC0)</div>
      </div>`;
    parent.appendChild(this.root);
    this.log = this.root.querySelector('.pause-log')!;
    this.vol = this.root.querySelector('input[type=range]')!;
    this.muteBtn = this.root.querySelector('[data-a=mute]')!;
    this.vol.value = String(volume);
    this.setMuted(muted);
    this.vol.addEventListener('input', () => this.onVolume(Number(this.vol.value)));
    this.root.querySelectorAll<HTMLButtonElement>('.pause-btn').forEach((b) =>
      b.addEventListener('click', () => {
        const a = b.dataset.a;
        if (a === 'resume') this.onResume();
        if (a === 'ship') this.onChangeShip();
        if (a === 'mute') this.setMuted(this.onMute());
      }),
    );
  }

  setMuted(m: boolean): void {
    this.muteBtn.textContent = m ? 'Sound: off' : 'Sound: on';
  }

  show(logbook: Logbook): void {
    this.open = true;
    this.root.classList.remove('hidden');
    document.exitPointerLock?.();
    this.log.innerHTML = LOG_ENTRIES.map((e) => `<li class="${logbook.has(e.id) ? 'done' : ''}">${e.label}</li>`).join('');
    (this.root.querySelector('[data-a=resume]') as HTMLButtonElement).focus();
  }

  hide(): void {
    this.open = false;
    this.root.classList.add('hidden');
  }
}
